import { useEffect, useState } from "react";
import { X, Mail } from "lucide-react";
import { toast } from "sonner";

export default function WelcomeOffer() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("ethos_offer_closed")) return;
    const t = setTimeout(() => setOpen(true), 10000);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    sessionStorage.setItem("ethos_offer_closed", "1");
    setOpen(false);
  };

  const submit = (e) => {
    e.preventDefault();
    if (!email) return;
    setDone(true);
    toast.success("You're signed up for exclusive deals");
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="welcome-offer-overlay">
      <div className="relative w-full max-w-md rounded-2xl bg-white text-foreground p-8 shadow-2xl border border-[#efe6d2] animate-fade-up" data-testid="welcome-offer" style={{ backgroundImage: "linear-gradient(160deg, #ffffff 0%, #fff8ee 100%)" }}>
        <button onClick={close} data-testid="welcome-offer-close" aria-label="Close" className="absolute top-3.5 right-3.5 text-muted-foreground hover:text-foreground">
          <X className="w-5 h-5" />
        </button>
        <span className="flex items-center gap-2 eyebrow text-champagne">
          <Mail className="w-3.5 h-3.5" /> Exclusive Deals
        </span>
        {done ? (
          <div className="mt-3">
            <p className="font-display font-bold text-2xl">You're in 🎉</p>
            <p className="text-muted-foreground text-sm mt-1">You'll be first to hear about new drops, restocks and members-only deals.</p>
          </div>
        ) : (
          <>
            <p className="font-display font-bold text-2xl mt-3">Sign up for exclusive deals</p>
            <p className="text-muted-foreground text-sm mt-1">Be first to hear about new drops, restocks and members-only offers.</p>
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 mt-5">
              <input
                data-testid="welcome-offer-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@lab.com"
                className="flex-1 h-11 rounded-lg bg-white border border-[#e4d9c2] px-3 text-sm placeholder:text-muted-foreground/60 focus:outline-none focus:border-champagne"
                required
              />
              <button type="submit" data-testid="welcome-offer-submit" className="h-11 px-5 rounded-lg btn-gold font-semibold text-sm">
                Sign up
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
